import React from 'react'

export const FormSectionTitle = (props) =>{
  return(
    <div className={`form-section-title ${props.first && 'first'}`}>{props.children}</div>
  )
}

export const FormRow = (props) =>{
  return (
    <div className="form-row">
      {props.children}
    </div>
  )
}

export const Label = (props) =>{
  return(
    <label>{props.children} <span className="warning-span">{props.required && '*'}</span><span style={{color:'darkgrey',fontWeight: 'lighter'}}> {props.help}</span></label>
  )
}

export const FormColumn = (props) =>{
  return (
    <div className={`form-column ${props.half && 'half'}`}>
      {props.children}
    </div>
  )
}

export default FormSectionTitle



// WEBPACK FOOTER //
// ./src/components/FormElements.js